import Service from "./Service"


export default class CatalogService extends Service {
    constructor() {
        super()
        this.serviceUrl = `https://api.travelski.com/catalog`
        this.mandatoryFields = {
            "getStationData": ['stationId', 'locale']
        }
    }


    async getStationData(requestData) {
        this.checkMandatoryFields(requestData, "getStationData")
        const {stationId, locale} = requestData
        const headers = {}
        const params = {locale}
        const url = `${this.serviceUrl}/place/station/${stationId}`
        const {data} = await this.axios.get(url, {params, headers})
        return data
    }

    async getPrestationByLocale(requestData) {
        this.checkMandatoryFields(requestData, "getPrestationByLocale")
        const {prestationId, locale} = requestData
        const headers = {}
        const params = {locale}
        const url = `${this.serviceUrl}/prestation/${prestationId}`
        const {data} = await this.axios.get(url, {params, headers})
        return data
    }
}

